import ProductLicense from './ProductLicense';

export default ProductLicense;
